module.exports = __webpack_public_path__ + "mo/img/puzzle_03.8fdc8011.svg";